/*
 *
 * RefoundBackbookISP
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 11-Mar-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  MIXED_ISP_ADMIN: {
    title: (
      <PortalMessage
        id='t.app.ttl.refound.backbook.mixed_isp_admin.title'
        defaultMessage='È disponibile la funzionalità storni per Intesa Sanpaolo'
      />
    ),
    description: (
      <PortalMessage
        id='t.app.ttl.refound.backbook.mixed_isp_admin.description'
        defaultMessage='Per iniziare a stornare, <b>inserisci il tuo Codice Fiscale personale</b> nel tuo profilo Nexi Business.'
      />
    ),
    primaryButtonLabel: (
      <PortalMessage
        id='t.app.ttl.refound.backbook.mixed_isp_admin.primaryButtonLabel'
        defaultMessage='Vai al profilo'
      />
    ),
    secondaryButtonLabel: (
      <PortalMessage
        id='t.app.okUnderstood'
        defaultMessage='Ok, ho capito'
      />
    )
  },
  MIXED_ISP_SECONDARY_OR_OPERATIVE: {
    title: (
      <PortalMessage
        id='t.app.ttl.refound.backbook.mixed_isp_secondary_or_operative.title'
        defaultMessage='È disponibile la funzionalità storni per Intesa Sanpaolo'
      />
    ),
    description: (
      <PortalMessage
        id='t.app.ttl.refound.backbook.mixed_isp_secondary_or_operative.description'
        defaultMessage='Da ora <b>è possibile stornare le transazioni sui punti vendita Intesa Sanpaolo</b>. <br/><br/>Per essere abilitato a questa funzionalità, <b>contatta il tuo Amministratore</b>.'
      />
    ),
    primaryButtonLabel: (
      <PortalMessage
        id='t.app.okUnderstood'
        defaultMessage='Ok, ho capito'
      />
    )
  }
}

export default formattedMessage
